//#region [IMPORT]

// === THIRD-PARTY ===
import { useContext, useEffect, useState } from 'react';

// === HOOKS ===
import { useSession } from 'pages/PageManager/components/SessionContext';

// === API ===
import { on, removeListener } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export const useTaskStatus = () => {
  //-----------------------------------------------------------------
  //#region [VALUES]

  const { user_details } = useSession();

  const [ has_task, setHasTask ] = useState(false);
  const [    views, setViews   ] = useState( {}  );
  const [       id, setId      ] = useState( null);

  const [     can_cancel, setCanCancel     ] = useState( false );
  const [ timeout_cancel, setTimeoutCancel ] = useState( null )

  //#endregion

  //#region [EFFECT]

  //-----------------------------------------------------------------
  async function handleTask(data) {
    //-----------------------------------------------------------------
    setId( data?.id );
    const result = data?.id ? true : false;
    setHasTask(result);
    setViews( data?.views );
    if( result ) {
      const timeout = setTimeout(() => {
        setCanCancel( true )
      }, user_details?.task_cancel_delay || 100 );
      setTimeoutCancel( timeout );
    } else {
      clearTimeout( timeout_cancel );
      setCanCancel( false );
    }
  }

  useEffect( () => {

    on( 'TASK_INFO', handleTask );
    
    return () => {
      removeListener( 'TASK_INFO' , handleTask );
      clearTimeout( timeout_cancel );
    };

  }, [user_details] );

  //#endregion

  return {id, has_task, views, can_cancel};
}